enum DisclosureTypeEnum {
    FULL_ACCESS = 'FULL_ACCESS',
    PARTIAL = 'PARTIAL',
}

namespace DisclosureTypeEnum {

    type AdditionalFields = { resourceKey: string, className: string };
    export type Entry = { enumKey: string } & AdditionalFields;

    const fieldsMap: Map<DisclosureTypeEnum, AdditionalFields> = new Map(
        [
            [DisclosureTypeEnum.FULL_ACCESS, {
                resourceKey: 'easeportal.enum.FULL-ACCESS',
                className: 'ecl-tag  sgp-disclosure-tag ecl-u-bg-green'
            }],
            [DisclosureTypeEnum.PARTIAL, {
                resourceKey: 'easeportal.enum.PARTIAL',
                className: 'ecl-tag  sgp-disclosure-tag ecl-u-bg-orange'
            }]
        ]);

    // Note: Without Array.from() the 'let ... of' loops cause: "type 'IterableIterator<>'
    // is not an array type or a string type" error when --downlevelIteration is not set
    // In any case here we do not stop to entries() IterableIterator.
    // We further map from [key: {resourceKey: }] to {enumKey: , resourceKey:}
    export const entries: Array<Entry> = Array.from(fieldsMap.entries()).map((v) => ({enumKey: v[0], ...v[1]}));
    // values of the enumerator
    export const values: Array<DisclosureTypeEnum> = Array.from(fieldsMap.keys());

    export const resourceKey = (e: DisclosureTypeEnum): string => {
        const x = fieldsMap.get(e);
        if (x === undefined) {
            throw Error('Invalid enum value');
        }// strictNullChecks require this
        return x.resourceKey;
    };

    export const className = (e: DisclosureTypeEnum): string => {
        const x = fieldsMap.get(e);
        if (x === undefined) {
            throw Error('Invalid enum value');
        }// strictNullChecks require this
        return x.className;
    };

}

export { DisclosureTypeEnum };
